import styled from 'styled-components';
import theme from '../../../../styles/theme';
import NaviText from '../../common/NaviText';
import Button from '../../../common/Button';
import { NumericFormat } from 'react-number-format';
import moment from 'moment';

import { useSetItem, useGetItemHistSel, useGetItemByTno, useGetItemLog } from '../../../../interface/item';
import React, { useCallback, useState, useEffect } from 'react';

import { ErrorMsg, Row, TabText } from '../../../../styles/common';
import { FormControl, Select, InputLabel, TextField, MenuItem, Fade, Autocomplete } from '@mui/material';
import { useGetCategoryList, useGetCodeList, useGetMafList, useGetUserList } from '../../../../interface/common';
import { TreeItem, TreeView } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CommonDataGrid from '../../../common/CommonDataGrid';
import MsgModal from '../../../common/modal/MsgModal';
import { useGetInoutHistStatic } from '../../../../interface/inout';


const MainWrap = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    .label {
        // display: flex;
        // align-items: center;//stretch;
        padding: 4px;
        min-width: 8rem;
        height: calc(100% - 8px);
        font-size:${theme.fontSize.base};
        // background: ${theme.color.black[40]};
        // border: 1px solid red;
    }
    .naviBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid ${theme.color.black[10]};
        position:sticky;
        top:0px;
        background: ${theme.color.white[100]};
        z-index:1200;
    }
    // .close {
    //     position: absolute;
    //     top: 0px;
    //     right: 0;
    // }
`;

const AssetItem = ({item, onClose}) => {

    return !item ? <InputForm onClose={onClose} /> : <InputForm pItem={item} onClose={onClose} />

}

const MFadePannel = styled.div`

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    border: 0;
    position: fixed;
    top: 0;
    left: 0;
    background: ${theme.color.black[60]};
    border-radius: 16px;
    z-index: 2000;
    display: flex;
    justify-content: center;
    align-items: center;
    > .pannel {
        position: relative;
        background: ${theme.color.white[100]};
        width: 340px;
        max-height: calc(80% - 80px);
        height: auto;
        padding: 16px;
        padding-top: 0;
        border-radius: inherit;
        overflow-y: auto;
    }

`;

const columns = [
    { field: 'reg_dt', headerName: '일시', flex:1 },
    { field: 'mod_tpnm', headerName: '변경내용', flex:0.5 },
    { field: 'descr1', headerName: '비고', flex:1 },
    { field: 'mod_stnm', headerName: '결과', flex:0.5 },
]

const inoutHistColumns = [
    // { field: 'tno', headerName: '자산번호', width:140 },
    // { field: 'pcat_nm', headerName: '구분', width:100 },
    // { field: 'cat_nm', headerName: '분류', width:150 },
    // { field: 'lot_no', headerName: '표기번호', width:120 },
    { field: 'reg_nm', headerName: '담당자', width:120 },
    { field: 'reg_dt', headerName: '등록일', width:150 },
    { field: 'io_stnm', headerName: '반출입구분', width:120 },
    { field: 'ret_stnnm', headerName: '반입상태', width:120 },
    { field: 'iot_nm', headerName: '과업명', width:250 },
    { field: 'iot_tpnm', headerName: '반출입분류', width:120 },
    { field: 'is_ing', headerName: '반출입작업상태', width:120 },
    { field: 'item_stnm', headerName: '자산상태', width:120 },
    // { field: 'maf_nm', headerName: '제조사', width:100 },
    // { field: 'model_nm', headerName: '모델명', width:120 },
    { field: 'contents', headerName: '내용', width:200 },
    { field: 'descr', headerName: '비고', width:200 },
    // { field: 'r_item', headerName: '연계자산', width:200 },
    // { field: 'location', headerName: '위치', width:120 },
    // { field: 'model_sub', headerName: '모델유형', width:120 },
    // { field: 'serial_no', headerName: '시리얼넘버', width:200 },
]

const InputForm = ({pItem,onClose}) => {

    const [sendItem, setSendItem] = useState(pItem?pItem:{maf_nm:''});

    const [tab,setTab] = useState('INFO');
    const [list, setList] = useState([]);
    const [uList, setUList] = useState([]);
    const [mList, setMList] = useState([]);
    const [itemInoutList, setItemInoutList] = useState([]);
    const [rid,setRid] = useState({});
    const [errorMsg, setErrorMsg] = useState();
    const [categoryTree, setCategoryTree] = useState();
    const [toggle,setToggle] = useState(false);
    const [modMsgToggle,setModMsgToggle] = useState(false);
    const [delMsgToggle,setDelMsgToggle] = useState(false);
    const [selectCategory,setSelectCategory] = useState(pItem?{cid:pItem.cid,cat_nm:pItem.cat_nm}:undefined);

    const { mutate, error } = useSetItem();
    const {data : statusList} = useGetCodeList('status');
    const {data : purTpList} = useGetCodeList('pur_tp');
    const {data : categoryList} = useGetCategoryList();
    const {data : mafList} = useGetMafList();
    const {data : userList} = useGetUserList();
    const {data : itemHist, isLoading: itemHistLoading} = useGetItemLog((pItem && pItem.tid) &&{tid:pItem.tid});
    const {data : itemInoutHist, isLoading, refetch} = useGetInoutHistStatic((pItem && pItem.tid) &&{tid:pItem.tid});
    const {data : rItem, isLoading: rItemLoading} = useGetItemByTno((pItem && pItem.rid) &&{tid:pItem.rid});

    const handleMafChange = (item) => {
        if(item){
            console.log(item)
            handleValueChange('maf_id',item.maf_id);
            handleValueChange('maf_nm',item.maf_nm);
        }else{
            handleValueChange('maf_id',undefined);
            handleValueChange('maf_nm',undefined);
        }
    }

    const handleSelectCategory = (pp) => {
        setSelectCategory(pp);
        if(pp){
            setToggle(false);
            handleValueChange('cid',pp.cid)
        }
    }

    const handleValueChange = (id, val) => {
        const temp = sendItem
        temp[id]=val
        setSendItem(temp);
    }

    const handleRegClick = useCallback(() => {
        sendItem['mode'] = 'POST'
        mutate(
            sendItem,
            {
                onSuccess:()=>{
                    onClose(false);
                },
                onError:(e)=>{
                    console.log('등록실패',e);
                }
            }
            );
    },[mutate]);

    const handleModConfirm = () => {
        setModMsgToggle(true)
    }

    const handleModClick = useCallback(() => {
        sendItem['mode'] = 'PUT'
        if(pItem && pItem.tid) {
            sendItem['tid']=pItem.tid;
        }
        mutate(
            sendItem,
            {
                onSuccess:()=>{
                    onClose(false);
                },
                onError:(e)=>{
                    console.log('수정실패',e);
                }
            }
            );
    },[mutate]);

    const handleDelConfirm = () => {
        setDelMsgToggle(true)
    }

    const handleDelClick = useCallback(() => {
        if(pItem && pItem.tid) {
            const delParam = {
                mode: 'DELETE',
                tid: pItem.tid
            }
            mutate(delParam);
            onClose(false);
        }
    },[mutate]);

//     useEffect(()=>{
// console.log(pItem,rItem)
//     },[pItem,rItem])
    
    useEffect(()=>{
        if(userList){
            setUList(userList.map((item,index)=>({
                ...item,
                label:item.user_nm})
                ));
        }
    },[userList])

    useEffect(()=>{
        if(mafList){
            setMList(mafList.map((item,index)=>({
                ...item,
                label:item.maf_nm})
                ));
        }
    },[mafList])

    useEffect(()=>{
        if(error && error !== null && error.response && error.response.data){
            setErrorMsg(error.response.data.message)
        }
    },[error])

    useEffect(()=>{
        const arrayToTree = (arr, parent = null) =>
                    arr.filter(item => item.pcid === parent)
                    .map(child => ({ ...child, children: arrayToTree(arr, child.cid) }));
        if(categoryList && categoryList[0]) {
            setCategoryTree(arrayToTree(categoryList[0]));
        }
    },[categoryList])

    useEffect(()=>{
        if(itemHist){
            setList(itemHist.map((item,index)=>({
                                            ...item,
                                            id:index,
                                            reg_dt: moment(item.reg_dt).format('YYYY/MM/DD HH:mm')})
                                            ));
        }else{
            setList([])
        }
    },[itemHist])

    useEffect(()=>{
        if(itemInoutHist){
            setItemInoutList(itemInoutHist.map((item,index)=>({
                ...item,
                reg_dt: moment(item.reg_dt).format('YYYY/MM/DD HH:mm'),
                id:index,
                r_item: 
                    (item.r_tno && item.r_tno === null) ? 
                    (item.s_tno !== null) ? (item.s_tno +' | '+ ((item.s_lot_no !== null && item.s_lot_no) !== '' ? item.s_lot_no : '-')) : '-'
                    : 
                    (item.r_tno !== null) ? (item.r_tno +' | '+ ((item.r_lot_no !== null && item.r_lot_no) !== '' ? item.r_lot_no : '-')) : '-' ,
                is_ing: item.is_ing === 0 ? '완료' : '진행중',
                ret_stnnm: item.io_st === 'O' ? ' - ': item.ret_stnnm, 
                reg_dt: moment(item.reg_dt).format('YYYY/MM/DD HH:mm')})
                ));
        }else{
            setItemInoutList([])
        }
    },[itemInoutHist])

    return (
        <MainWrap>
            <div className='naviBar'>
                <NaviText target={[{text:'자산관리'},{text:pItem ? pItem.tno : '자산등록'}]} />
                <div className='close' onClick={()=>onClose(false)}>
                    <img src={`/images/ic_close.svg`} />
                </div>
            </div>
            <div 
                style={{
                    flexGrow:1,
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'flex-start'
                }}
            >
                <Fade in={toggle}>
                    <MFadePannel>
                        <div className='pannel'>
                            <div className='naviBar' >
                                <NaviText target={[{text:'자산관리'},{text:'자산등록'}, {text:'분류 선택'}]} />
                                <div className='close' style={{top:'24px',right:'16px'}} onClick={()=>setToggle(false)}>
                                    <img src={`/images/ic_close.svg`} />
                                </div>
                            </div>
                            <div style={{height:'16px'}} />
                            {categoryTree &&
                                <TreeView
                                    aria-label="rich object"
                                    defaultCollapseIcon={<ExpandMoreIcon />}
                                    defaultExpanded={['root']}
                                    defaultExpandIcon={<ChevronRightIcon />}
                                    sx={{ flexGrow: 1, maxWidth: 200}}
                                >
                                    {categoryTree && categoryTree.map((item,index)=>{
                                        return renderTree(item,handleSelectCategory)
                                    })}
                                </TreeView>
                            }
                        </div>
                    </MFadePannel>
                </Fade>
                <Row >
                    <TabText selected={tab==='INFO'} onClick={()=>setTab('INFO')}>자산 정보</TabText>
                    {(rItem && rItem[0].tid) && <TabText selected={tab==='RITEM'} onClick={()=>setTab('RITEM')}>연계 자산</TabText>}
                    {(pItem && pItem.tid) && <TabText selected={tab==='HIST'} onClick={()=>setTab('HIST')}>변경 이력</TabText>}
                    {(pItem && pItem.tid) && <TabText selected={tab==='INOUT_HIST'} onClick={()=>setTab('INOUT_HIST')}>반출입 이력</TabText>}
                </Row>
                {tab==='INFO' ? 
                <React.Fragment>
                <Row style={{marginTop:'8px'}}>
                    {(pItem && pItem.tno && pItem.tno !== '') &&
                        <TextField 
                            id='tno' 
                            label='자산번호' 
                            size='small' 
                            style={{width:'8.5rem'}}
                            value={pItem && pItem.tno}
                            InputProps={{
                                readOnly: true,
                              }}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                    }
                    <TextField
                        label='분류'
                        InputProps={{
                            readOnly: true,
                          }}
                        InputLabelProps={{shrink:true}} 
                        size='small'
                        placeholder='분류선택'
                        style={{width:'8.5rem'}}
                        value={selectCategory ? selectCategory.cat_nm : ''}
                        onClick={()=>setToggle(true)}
                    />
                    <Autocomplete
                        id="maf_id"
                        size='small'
                        options={mList}
                        sx={{ width: 160 }}
                        defaultValue={pItem && pItem.maf_nm}
                        renderInput={(params) => <TextField {...params} label="제조사" />}
                        onChange={(e,v)=>v!==null&&handleValueChange('maf_id',v.maf_id)}
                        />
                    {/* <FormControl style={{width:'10rem'}} size='small'>
                        <InputLabel id='maf-label'>제조사</InputLabel>
                        <Select label="제조사" labelId='maf-label' size='small' defaultValue={pItem && pItem.maf_id}>
                            {mafList && mafList.map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.maf_id} 
                                            onClick={()=>handleValueChange('maf_id',item.maf_id)}
                                        >
                                            {item.maf_nm}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl> */}
                    <TextField 
                        id='model_nm' 
                        label='모델명' 
                        size='small' 
                        style={{width:'8.5rem'}}
                        InputLabelProps={{shrink:true}} 
                        defaultValue={pItem && pItem.model_nm}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        id='model_sub' 
                        label='모델유형' 
                        size='small' 
                        style={{width:'8.5rem'}}
                        InputLabelProps={{shrink:true}} 
                        defaultValue={pItem && pItem.model_sub}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <FormControl style={{width:'8.5rem'}} size='small'>
                        <InputLabel id='status-label'>자산상태</InputLabel>
                        <Select label="자산상태" labelId='status-label' size='small' defaultValue={pItem && pItem.status}>
                            {statusList && statusList.map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.code} 
                                            onClick={()=>handleValueChange('status',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                    <TextField 
                        id='location' 
                        label='위치' 
                        style={{width:'8.5rem'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={pItem && pItem.location}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        id='lot_no' 
                        label='표기번호' 
                        size='small' 
                        style={{width:'10rem'}} 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={pItem && pItem.lot_no}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        id='serial_no' 
                        label='시리얼넘버' 
                        style={{width:'14rem'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={pItem && pItem.serial_no}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='maf_date'
                        label='제조일자' 
                        style={{width:'10rem'}} 
                        InputLabelProps={{shrink:true}} 
                        type='date' 
                        size='small' 
                        defaultValue={pItem && moment(pItem.maf_date).format('YYYY-MM-DD')}
                        onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                    />
                    <TextField 
                        id='pur_date'
                        label='구매일자' 
                        style={{width:'10rem'}} 
                        InputLabelProps={{shrink:true}} 
                        type='date' 
                        size='small'
                        defaultValue={pItem && moment(pItem.maf_date,'YYYYMMDD').format('YYYY-MM-DD')}
                        onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                    />
                    <FormControl style={{width:'7rem'}} size='small'>
                        <InputLabel id='purTp-label'>구매구분</InputLabel>
                        <Select label="구매구분" labelId='purTp-label' size='small' defaultValue={pItem && pItem.pur_tp}>
                            {purTpList && purTpList.map((item,index)=>{ 
                                return <MenuItem 
                                            key={index} 
                                            value={item.code}
                                            onClick={()=>handleValueChange('pur_tp',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                    <TextField 
                        id='pur_price'
                        label='구매가격' 
                        InputProps={{
                            inputProps: {style:{width:'130px',textAlign:'right'}},
                            inputComponent: NumberFormatCustom,
                        }}
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={pItem && pItem.pur_price}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <Autocomplete
                        id="uid1"
                        size='small'
                        options={uList}
                        sx={{ width: 120 }}
                        defaultValue={pItem && pItem.uid1_nm}
                        renderInput={(params) => <TextField {...params} label="책임자" />}
                        onChange={(e,v)=>v!==null&&handleValueChange('uid1',v.uid)}
                        />
                    <Autocomplete
                        id="uid2"
                        size='small'
                        options={uList}
                        sx={{ width: 120 }}
                        defaultValue={pItem && pItem.uid2_nm}
                        renderInput={(params) => <TextField {...params} label="부책임자" />}
                        onChange={(e,v)=>v!==null&&handleValueChange('uid2',v.uid)}
                        />
                    {/* <FormControl style={{width:'6rem'}} size='small'>
                        <InputLabel id='uid1-label'>책임자</InputLabel>
                        <Select label="책임자" labelId='uid1-label' size='small' defaultValue={pItem && pItem.uid1}>
                            {userList && userList.map((item,index)=>{ 
                                return <MenuItem 
                                            key={index} 
                                            value={item.uid}
                                            onClick={()=>handleValueChange('uid1',item.uid)}
                                        >
                                            {item.user_nm}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl> */}
                    {/* <FormControl style={{width:'6rem'}} size='small'>
                        <InputLabel id='uid2-label'>부책임자</InputLabel>
                        <Select label="부책임자" labelId='uid2-label' size='small' defaultValue={pItem && pItem.uid2}>
                            {userList && userList.map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.uid}
                                            onClick={()=>handleValueChange('uid2',item.uid)}
                                        >
                                            {item.user_nm}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl> */}
                </Row>
                <Row>
                    <TextField 
                        id='spec' 
                        label='사양' 
                        fullWidth 
                        multiline 
                        rows={2} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={pItem && pItem.spec}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='descr1' 
                        label='비고1' 
                        fullWidth 
                        multiline 
                        rows={4} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={pItem && pItem.descr1}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='descr2' 
                        label='비고2' 
                        fullWidth 
                        multiline 
                        rows={4} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={pItem && pItem.descr2}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='io_descr' 
                        label='반출입 관리 메모' 
                        fullWidth 
                        multiline 
                        InputProps={{
                            readOnly: true,
                          }}
                        rows={4} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={pItem && pItem.io_descr}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                </React.Fragment>
                :tab==='RITEM' ? 
                <React.Fragment>
                <Row style={{marginTop:'8px'}}>
                    {(rItem && rItem[0].tno && rItem[0].tno !== '') &&
                        <TextField 
                            id='r_tno' 
                            label='자산번호' 
                            size='small' 
                            style={{width:'8.5rem'}}
                            value={rItem && rItem[0].tno}
                            InputProps={{
                                readOnly: true,
                              }}
                            // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                    }
                    <TextField
                        label='분류'
                        InputProps={{
                            readOnly: true,
                          }}
                        InputLabelProps={{shrink:true}} 
                        size='small'
                        placeholder='분류선택'
                        style={{width:'8.5rem'}}
                        value={rItem ? rItem[0].cat_nm : ''}
                        // defaultValue={rItem && rItem[0].tno}
                        // onClick={()=>setToggle(true)}
                    />
                    <TextField
                        label='제조사'
                        InputProps={{
                            readOnly: true,
                          }}
                        InputLabelProps={{shrink:true}} 
                        size='small'
                        placeholder='제조사'
                        style={{width:'8.5rem'}}
                        value={rItem ? rItem[0].maf_nm : ''}
                        // defaultValue={rItem && rItem[0].tno}
                        // onClick={()=>setToggle(true)}
                    />
                    <TextField 
                        id='model_nm' 
                        label='모델명' 
                        size='small' 
                        style={{width:'8.5rem'}}
                        defaultValue={rItem && rItem[0].model_nm}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        label='모델유형' 
                        size='small' 
                        style={{width:'8.5rem'}}
                        InputLabelProps={{shrink:true}} 
                        value={rItem && rItem[0].model_sub}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='model_sub' 
                        label='상태' 
                        size='small' 
                        style={{width:'8.5rem'}}
                        value={rItem && rItem[0].status_nm}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        id='location' 
                        label='위치' 
                        style={{width:'8.5rem'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        value={rItem && rItem[0].location}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        id='lot_no' 
                        label='표기번호' 
                        size='small' 
                        style={{width:'10rem'}} 
                        InputLabelProps={{shrink:true}} 
                        value={rItem && rItem[0].lot_no}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        id='serial_no' 
                        label='시리얼넘버' 
                        style={{width:'14rem'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        value={rItem && rItem[0].serial_no}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='maf_date'
                        label='제조일자' 
                        style={{width:'10rem'}} 
                        InputLabelProps={{shrink:true}} 
                        type='date' 
                        size='small' 
                        value={rItem && moment(rItem[0].maf_date).format('YYYY-MM-DD')}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                    />
                    <TextField 
                        id='pur_date'
                        label='구매일자' 
                        style={{width:'10rem'}} 
                        InputLabelProps={{shrink:true}} 
                        type='date' 
                        size='small'
                        value={rItem && moment(rItem[0].pur_date,'YYYYMMDD').format('YYYY-MM-DD')}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                    />
                    <TextField 
                        label='구매구분' 
                        style={{width:'7rem'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        value={rItem && rItem[0].pur_tpnm}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        id='pur_price'
                        label='구매가격' 
                        InputLabelProps={{shrink:true}} 
                        InputProps={{
                            readOnly: true,
                            inputProps: {style:{width:'130px',textAlign:'right'}},
                            inputComponent: NumberFormatCustom,
                        }}
                        size='small' 
                        value={rItem && rItem[0].pur_price}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        label='책임자' 
                        style={{width:'6rem'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        value={rItem && rItem[0].uid1_nm}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        label='부책임자' 
                        style={{width:'6rem'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        value={rItem && rItem[0].uid2_nm}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='spec' 
                        label='사양' 
                        fullWidth 
                        multiline 
                        rows={2} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        value={rItem && rItem[0].spec}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='descr1' 
                        label='비고1' 
                        fullWidth 
                        multiline 
                        rows={2} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        value={rItem && rItem[0].descr1}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='descr2' 
                        label='비고2' 
                        fullWidth 
                        multiline 
                        rows={2} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        value={rItem && rItem[0].descr2}
                            InputProps={{
                                readOnly: true,
                              }}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                </React.Fragment> 
                : (tab === 'HIST') ?
                <CommonDataGrid
                    isLoading={itemHistLoading}
                    list={list}
                    columns={columns}
                    // onRowClick={(e)=>{handleItemClick(e.row)}}
                    />
                :
                <CommonDataGrid
                    isLoading={isLoading}
                    list={itemInoutList}
                    columns={inoutHistColumns}
                    // onRowClick={(e)=>{handleItemClick(e.row)}}
                    />
            }
            </div>
            {tab==='INFO' &&
                <React.Fragment>
                    {errorMsg && <ErrorMsg>{errorMsg}</ErrorMsg>}
                    {(pItem && pItem.tid) ?
                    <div style={{display:'grid',gridTemplateColumns:'80% 20%'}}>
                        <Button onClick={handleModConfirm}>수정</Button>
                        <Button onClick={handleDelConfirm}>삭제</Button>
                    </div>
                    :
                    <div>
                        <Button onClick={handleRegClick}>등록</Button>
                    </div>
                    }
                </React.Fragment>
            }
            <MsgModal open={modMsgToggle}>
                <div style={{height:'100%',textAlign:'center',display:'flex',flexDirection:'column',justifyContent:'space-between'}} onClick={()=>setModMsgToggle(false)}>
                    <h2>수정 하시겠습니까?</h2>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                        <Button onClick={handleModClick}>수정</Button>
                        <Button onClick={()=>setModMsgToggle(false)}>취소</Button>
                    </div>
                </div>
            </MsgModal>
            <MsgModal open={delMsgToggle}>
                <div style={{height:'100%',textAlign:'center',display:'flex',flexDirection:'column',justifyContent:'space-between'}} onClick={()=>setDelMsgToggle(false)}>
                    <h2>삭제 하시겠습니까?</h2>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                        <Button onClick={handleDelClick}>삭제</Button>
                        <Button onClick={()=>setDelMsgToggle(false)}>취소</Button>
                    </div>
                </div>
            </MsgModal>
        </MainWrap>
    )
}



const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;
  
    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              id: props.id,
              name: props.name,
              value: values.value,
            },
  
          });
        }}
        thousandSeparator
        isNumericString
        prefix="₩"
      />
    );
  });
  

const renderTree = (nodes,getItem) => {
    const handleClick = () => {
        getItem((Array.isArray(nodes.children) && nodes.children.length>0)? undefined : nodes)
    }
    return (
    <TreeItem key={nodes.cid} nodeId={nodes.cid} label={nodes.cat_nm} onClick={handleClick}>
    {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node,getItem))
        : null}
    </TreeItem>
    )
}


export default AssetItem;